import i18n from "@/i18n";
import { CardLimit } from "fs-pb-vue2/data/cardLimits";
import { CardLimitsModalVue } from "fs-pb-vue2/vueModels/cardOperations/CardLimitsModalVue";
import sumFilter from "fs-pb-vue2/filters/sum.filter";

/**
 *  Класс для компоненты установки лимитов.
 */
export class CardLimitsModalVueGB extends CardLimitsModalVue {

  /** Текущий выбранный лимит */
  selectedLimit: any = {
    dayLimit: '',
    cardRefId: ''
  };

  /** флаг, указывающий находится ли лимит в режиме редактирования */
  editingLimit: boolean = false;

  dayLimit: string | number = '';

  cardRefId: string | number = '';

  originalLimit: string | null = null;

  /** Выбор лимита для редактирования */
  selectEditLimitGB(limit, params) {
    this.selectedLimit = limit;
    this.selectedLimit.cardRefId = params.cardRefId;
    this.originalLimit = this.selectedLimit.dayLimit;
    this.editingLimit = true;
    this.setLimitValues(limit);

    this.OperationModel.selectedLimit = limit;
  }

  formatInput(value) {
    const formattedValue = sumFilter(value);
    this.selectedLimit.dayLimit = formattedValue;
    this.originalLimit = formattedValue;
  }

  goBackToList() {
    this.editingLimit = false;
    this.initOperation();
  }

  get filteredCardLimits() {
    return this.OperationModel && this.OperationModel.cardLimits ? this.OperationModel.cardLimits.filter(limit => limit.CategoryCaption) : [];
  }

  get isPeriodGB(): (cardLimit: CardLimit) => boolean {
    return (cardLimit: CardLimit) => cardLimit.Period == 1 || cardLimit.Period == 2;
  }
  
  get isLimitEditableGB(): (cardLimit: CardLimit) => boolean {
    return (cardLimit: CardLimit) => 
      (this.isPeriodGB(cardLimit) && !cardLimit.SummaIsReadOnly) 
      || (cardLimit.isSwitch && !cardLimit.CountIsReadOnly && (!cardLimit.GlobCount || cardLimit.GlobCount > 0));
  }

  setLimitValues(props) {
    this.selectedLimit = props;

    if (props.IndSumma == 0) {
      this.selectedLimit.dayLimit = sumFilter(0);
    } else {
      this.selectedLimit.dayLimit = props.IndSumma ? sumFilter(props.IndSumma) : '';
    }
    this.originalLimit = this.selectedLimit.dayLimit;
  }

  /** Правила проверки лимитов */
  get checkRulesLimit() {
    const rules = [
      (value: string) => !this.isExceedingMaxLimit(value) || i18n.t("main.cards.limits.errors.maxLimited"),
      (value: string) => !this.isUnchanged(value) || i18n.t("main.cards.limits.errors.noСhange")
    ];
    return rules;
  }

  /** Проверка, не превышает ли введенное значение максимальный лимит */
  isExceedingMaxLimit(value: string): boolean {
    if (this.selectedLimit.GlobSumma) {
      const maxLimit = parseFloat(this.selectedLimit.GlobalSumLimitRem.replace(/\s/g, '').replace(',', '.'));
      const enteredValue = parseFloat(value.replace(/\s/g, '').replace(',', '.'));
      return enteredValue > maxLimit;
    }
    return false;
  }

  /** Проверка, не изменилось ли введенное значение по сравнению с оригинальным. */
  isUnchanged(value: string): boolean {
    const originalLimitNumber = parseFloat(this.originalLimit.replace(/\s/g, '').replace(',', '.'));
    const enteredValueNumber = parseFloat(value.replace(/\s/g, '').replace(',', '.'));
    return originalLimitNumber === enteredValueNumber;
  }
}
